import Iframe, { IframeTypeEnum } from 'components/Iframe'
import EFTDisclosureModal from 'components/Modals/EFTDisclosureModal'
import ErrorMessageModal from 'components/Modals/ErrorMessageModal'
import LoaderModal from 'components/Modals/LoaderModal'
import { useNorthCapitalApi } from 'hooks/useNorthCapitalAPI'
import { useRiseUpAPIV1 } from 'hooks/useRiseUpAPIV1'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import ReactGA from 'react-ga4'
import { useLocation, useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import { getModifiedUrlWithStep } from 'utils'
import { consoleLog } from 'utils/simpleLogger'
import CompanyLogo from '../../../assets/afbc.png'
import Side1 from '../../../assets/new_side_12.jpg'
import Button from '../../../components/Button'
import Stepper from '../../../components/Stepper'
import { IFormProps } from '../../../interfaces'

const BankAccount = (props: IFormProps) => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [iFrameKey, setIframeKey] = useState('iFrame01')
  const [showEFTDisclosureModal, setShowEFTDisclosureModal] = useState(false)

  const { getOnboardProgress, finalizeUserCreation } = useRiseUpAPIV1()
  const { createTrade, initiateACHPayment } = useNorthCapitalApi()
  const navigate = useNavigate()
  const location = useLocation()

  const getFreshBearerToken = async () => {
    const getOnboardProgressRes = await getOnboardProgress(props.getValues('onboardingId'))
    if (getOnboardProgressRes.status === 200) {
      return getOnboardProgressRes.data.accessToken
    }
  }

  const performTrade = async (accessToken: string) => {
    const res = await createTrade(
      props.getValues('investingProfile.accountId'),
      'ACH',
      props.getValues('investingProfile.totalShares'),
      accessToken,
    )
    consoleLog('create trade response', res)
    props.setValue('investingProfile.tradeId', Number(res.data.purchaseDetails[1][0].tradeId))
  }

  const performPayment = async (accessToken: string, nickname: string) => {
    props.setValue('investingProfile.nickname', nickname)

    const res = await initiateACHPayment(
      props.getValues('investingProfile.accountId'),
      String(props.getValues('investingProfile.tradeId')),
      `${nickname}`,
      Number(props.getValues('investingProfile.amount')),
      String(props.getValues('investingProfile.tradeId')),
      `ACH payment of $${props.getValues('investingProfile.amount')} with Trade ID: ${props.getValues(
        'investingProfile.tradeId',
      )}`,
      accessToken,
    )
    if (res.status === 101 || res.status === 200) {
      const res = await finalizeUserCreation(props.getValues('onboardingId'))
      consoleLog('finalizeUserCreation Error', res)
      const pathname = location.pathname
      const currentParams = queryString.parse(location.search)
      const updatedUrl = getModifiedUrlWithStep(pathname, currentParams, 'success_page')
      navigate(updatedUrl)
      props.nextStep('Success')
    }
    consoleLog('initiateACHPayment response', res)
  }

  const handleProceedToPayments = async (nickname: string) => {
    setIsLoading(true)

    try {
      const accessToken = await getFreshBearerToken()
      await performTrade(accessToken)
      await performPayment(accessToken, nickname)
    } catch (error) {
      console.log(error)
      ReactGA.event({
        category: 'ACH Payment page',
        action: `ACH Payment page error`,
        label: JSON.stringify(error),
      })
      swal({
        title: 'Error!',
        text: 'Please check if your details are valid and correct. If error persists, contact us.',
        icon: 'error',
      })
    }

    // try {
    //   const res = await createTrade(
    //     props.getValues('investingProfile.accountId'),
    //     'ACH',
    //     props.getValues('investingProfile.totalShares'),
    //     accessToken,
    //   )
    //   consoleLog('create trade response', res)
    //   props.setValue('investingProfile.tradeId', Number(res.data.purchaseDetails[1][0].tradeId))
    // } catch (error) {
    //   consoleLog('create trade error', error)
    //   setIsLoading(false)
    // }

    // try {
    //   const res = await initiateACHPayment(
    //     props.getValues('investingProfile.accountId'),
    //     String(props.getValues('investingProfile.tradeId')),
    //     `${type}`,
    //     Number(props.getValues('investingProfile.amount')),
    //     String(props.getValues('investingProfile.tradeId')),
    //     `ACH payment of $${props.getValues('investingProfile.amount')} with Trade ID: ${props.getValues(
    //       'investingProfile.tradeId',
    //     )}`,
    //     accessToken,
    //   )
    //   if (res.status === 101 || res.status === 200) {
    //     const res = await finalizeUserCreation(props.getValues('onboardingId'))
    //     consoleLog('finalizeUserCreation Error', res)
    //     props.nextStep('Success')
    //   }
    //   consoleLog('initiateACHPayment response', res)
    // } catch (error) {
    //   setIsLoading(false)
    //   consoleLog('initiateACHPayment error', error)
    // }
  }

  const onCancel = () => {
    props.previousStep('8')
  }

  useEffect(() => {
    props.setValue(
      'financialInfo.accountName',
      props.getValues('basicInfo.firstName') + ' ' + props.getValues('basicInfo.lastName'),
    )
    props.setValue('financialInfo.bankName', 'Bank of America')
  }, []) // eslint-disable-line

  return (
    <div className="flex h-screen w-full flex-col md:flex-row md:justify-start">
      <div className="mt-10 flex flex-col sm:w-screen md:mt-0 md:min-h-screen md:w-[45%] lg:w-[40%] xl:w-[35%]">
        <div className="relative sm:h-auto sm:p-16 md:hidden">
          <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
        </div>
        <div className="relative hidden flex-grow md:flex">
          <img className="flex h-screen w-full" src={Side1} alt="Side1" />
        </div>
      </div>

      <div className="flex flex-col p-10 sm:w-[100%] md:w-[55%] lg:h-screen lg:w-[60%] lg:overflow-y-scroll xl:w-[65%]">
        <div className="md:my-3">
          <Stepper current={props.currentStage} />
        </div>

        <div className="z-10 pb-8 pt-10 text-left text-2xl font-semibold text-gray-900 md:text-4xl lg:pb-10">
          Let's process your payment
        </div>

        <div className="md:px-0">
          {props.getValues('paymentIframe') && props.getValues('paymentIframe') !== '' && (
            <div className="mt-[-30px] flex justify-center md:justify-start">
              <Iframe
                source={props.getValues('paymentIframe')}
                key={iFrameKey}
                onCancel={onCancel}
                proceed={handleProceedToPayments}
                title={'Link Bank Account'}
                type={IframeTypeEnum.ACH}
              />
            </div>
          )}

          {/* {showReloadButton && (
            <div className="flex w-[30%] justify-center md:justify-start">
              <Button
                btnName={'Reload payment process'}
                btnType={'button'}
                onClickHandler={() => {
                  setIframeKey(Math.random().toString())
                  setShowReloadButton(false)
                }}
              />
            </div>
          )} */}
          <div className="mt-4 text-base leading-5 text-gray-500">
            By clicking "Continue", you authorize this transaction and agree to our{' '}
            <span
              className="cursor-pointer font-semibold text-blue-600 underline"
              onClick={() => window.open('https://ownarmedforcesbrewingco.com/terms/')}
            >
              Terms of Use
            </span>{' '}
            &{' '}
            <span
              className="cursor-pointer font-semibold text-blue-600 underline"
              onClick={() => setShowEFTDisclosureModal(true)}
            >
              EFT Disclosure
            </span>
            .
          </div>
          <div className="w-full justify-center gap-3 py-4 sm:block md:flex md:justify-start">
            <div className="flex flex-col sm:w-[100%] md:w-[20%]">
              <Button btnName={'Back'} onClickHandler={() => props.previousStep('8')} />
            </div>
          </div>
        </div>
      </div>
      <LoaderModal isVisible={isLoading} />
      <ErrorMessageModal
        isVisible={error !== ''}
        onProceed={() => {
          setError('')
        }}
        onCancel={() => {}}
        error={error}
        btn2={'Ok'}
      />
      <EFTDisclosureModal isVisible={showEFTDisclosureModal} setClose={() => setShowEFTDisclosureModal(false)} />
    </div>
  )
}

export default BankAccount
